import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import { Redirect } from 'react-router-dom';
import Configuration from '../Configuration';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class TopMenu extends Component {
  constructor() {
    super();
    this.state = {current: 'start', loggedIn: false, redirect: false};
    this.handleClick = this.handleClick.bind(this);
    this.showMenuItem = this.showMenuItem.bind(this);
    this.handleLogout= this.handleLogout.bind(this);
  }

  componentDidMount() {
    if(localStorage.getItem('visitapp:token')) {
      this.setState({loggedIn: true});
    }
  }
  
  handleClick(event) {
    this.setState({current: event.key});
  }

  handleLogout() {
    localStorage.removeItem('token');
    this.setState({redirect: true});
  }

  showMenuItem(status) {
    if(this.state.loggedIn === status) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Redirect with logout
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render menu
    if (Configuration.isInRol(localStorage.getItem('visitapp:rol'), "empleado")) {
      return (
        <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
          <Menu.Item key="logo">Visitapp</Menu.Item>
          <SubMenu title={<span><Icon type="car" /> Visitas</span>}>
            <MenuItemGroup title="Reportes">
              <Menu.Item key="visits:3"><a href="/visits-for-employee">Todas</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          <SubMenu title={<span><Icon type="message" /> Soporte</span>}>
            <MenuItemGroup title="Comunicación">
              <Menu.Item key="comunication:1"><a href="/support/tickets">Tickets</a></Menu.Item>
              <Menu.Item key="comunication:2"><a href="/support/chat">Chat con caseta</a></Menu.Item>
            </MenuItemGroup>
            <MenuItemGroup title="Capacitación">
              <Menu.Item key="learn:1"><a href="/support/videos">Videos</a></Menu.Item>
              <Menu.Item key="learn:2"><a href="/support/manuals">Manuales</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          <Menu.Item key="logout" style={{float: 'right', display: this.showMenuItem(true)}}>
            <a href="" className="text-danger" onClick={this.handleLogout}><Icon type="user" /> Logout</a>
          </Menu.Item>
          <Menu.Item key="login" style={{float: 'right', display: this.showMenuItem(false)}}>
            <a href="/login"><Icon type="user" /> Login</a>
          </Menu.Item>
        </Menu>
      );
    } else {
      return (
        <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
          <Menu.Item key="logo">Visitapp</Menu.Item>
          <SubMenu title={<span><Icon type="setting" /> Empresa</span>}>
            <MenuItemGroup title="Administración">
              <Menu.Item key="setting:1"><a href="/admin/branches">Sucursales</a></Menu.Item>
              <Menu.Item key="setting:2"><a href="/admin/departments">Departamentos</a></Menu.Item>
              <Menu.Item key="setting:3"><a href="/admin/warehouses">Almacenes</a></Menu.Item>
            </MenuItemGroup>
            <MenuItemGroup title="General">
              <Menu.Item key="setting:4"><a href="/admin/general-configuration">Configuración general</a></Menu.Item>
              <Menu.Item key="setting:5"><a href="/admin/messages-configuration">Configuración de Email / SMS</a></Menu.Item>
              <Menu.Item key="setting:6"><a href="/admin/levels">Niveles de autorización</a></Menu.Item>
              <Menu.Item key="setting:7"><a href="/admin/bulk-visitors">Importación de visitantes</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          <SubMenu title={<span><Icon type="user" /> Usuarios</span>}>
            <MenuItemGroup title="Administración">
              <Menu.Item key="users:1"><a href="/admin/users">Usuarios</a></Menu.Item>
              <Menu.Item key="users:2"><a href="/admin/cars">Autos</a></Menu.Item>
              <Menu.Item key="users:3"><a href="/admin/tags">Tags / Tarjetas</a></Menu.Item>
              <Menu.Item key="users:4"><a href="/admin/jobs">Puestos</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          <SubMenu title={<span><Icon type="car" /> Visitas</span>}>
            <MenuItemGroup title="Reportes">
              <Menu.Item key="visits:1"><a href="/visits/today">De hoy</a></Menu.Item>
              <Menu.Item key="visits:2"><a href="/visits/branch">Por Sucursales</a></Menu.Item>
              <Menu.Item key="visits:3"><a href="/visits/employee">Por Empleado</a></Menu.Item>
              <Menu.Item key="visits:4"><a href="/visits/authorize">Por Autorizar</a></Menu.Item>
              <Menu.Item key="visits:5"><a href="/visits/inside">Dentro de planta</a></Menu.Item>
              <Menu.Item key="visits:6"><a href="/visits/carrier">Transportista</a></Menu.Item>
              <Menu.Item key="visits:7"><a href="/visits/all">Todas</a></Menu.Item>
            </MenuItemGroup>
            <MenuItemGroup title="Administración">
              <Menu.Item key="visitors:5"><a href="/admin/plates">Lista negra</a></Menu.Item>
              <Menu.Item key="visitors:1"><a href="/admin/services">Tipos de servicios</a></Menu.Item>
              <Menu.Item key="visitors:2"><a href="/admin/transports">Tipos de transportes</a></Menu.Item>
              <Menu.Item key="visitors:3"><a href="/admin/visit_companies">Empresas externas</a></Menu.Item>
              <Menu.Item key="visitors:4"><a href="/admin/visitors">Visitantes</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          <SubMenu title={<span><Icon type="idcard" /> Transportistas</span>}>
            <MenuItemGroup title="Administración">
              <Menu.Item key="carriers:1"><a href="/admin/visit_ticket_kinds">Tipos de tickets</a></Menu.Item>
              <Menu.Item key="carriers:2"><a href="/admin/truck_kinds">Tipos de camiones</a></Menu.Item>
              <Menu.Item key="carriers:3"><a href="/admin/carriers">Transportistas</a></Menu.Item>
              <Menu.Item key="carriers:4"><a href="/admin/trucks">Camiones</a></Menu.Item>
              <Menu.Item key="carriers:5"><a href="/admin/drivers">Conductores</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          <SubMenu title={<span><Icon type="message" /> Soporte</span>}>
            <MenuItemGroup title="Comunicación">
              <Menu.Item key="comunication:1"><a href="/support/chat">Chat con caseta</a></Menu.Item>
            </MenuItemGroup>
            <MenuItemGroup title="Capacitación">
              <Menu.Item key="learn:1"><a href="/support/videos">Videos</a></Menu.Item>
              <Menu.Item key="learn:2"><a href="/support/manuals">Manuales</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>
          {/*<SubMenu title={<span><Icon type="pie-chart" /> Reportes</span>}>
            <MenuItemGroup title="">
              <Menu.Item key="report:1"><a href="/reports/visits">Visitas</a></Menu.Item>
              <Menu.Item key="report:2"><a href="/reports/employees">Empleados</a></Menu.Item>
              <Menu.Item key="report:3"><a href="/reports/carriers">Transportistas</a></Menu.Item>
            </MenuItemGroup>
          </SubMenu>*/}
          <Menu.Item key="logout" style={{float: 'right', display: this.showMenuItem(true)}}>
            <a href="" className="text-danger" onClick={this.handleLogout}><Icon type="user" /> Logout</a>
          </Menu.Item>
          <Menu.Item key="login" style={{float: 'right', display: this.showMenuItem(false)}}>
            <a href="/login"><Icon type="user" /> Login</a>
          </Menu.Item>
        </Menu>
      );
    }
  }
}

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/TopMenu.js